const icon = require('vue-svgicon');
icon.register({
    'receipt': {
        width: 24,
        height: 24,
        viewBox: '0 0 256 256',
        data: `<path pid="0" d="M72 104a8 8 0 018-8h96a8 8 0 010 16H80a8 8 0 01-8-8zm8 40h96a8 8 0 000-16H80a8 8 0 000 16zm152-88v152a8 8 0 01-11.58 7.15L192 200.94l-28.42 14.21a8 8 0 01-7.16 0L128 200.94l-28.42 14.21a8 8 0 01-7.16 0L64 200.94l-28.42 14.21A8 8 0 0124 208V56a16 16 0 0116-16h176a16 16 0 0116 16zm-16 0H40v139.06l20.42-10.22a8 8 0 017.16 0L96 199.06l28.42-14.22a8 8 0 017.16 0L160 199.06l28.42-14.22a8 8 0 017.16 0L216 195.06z"/>`,
    },
});
